import _implicitStylesheets from "./popover.css";
import _implicitScopedStylesheets from "./popover.scoped.css?scoped=true";
import _axIconInteractive from "ax/iconInteractive";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div${"c0"}${2}></div>`;
const stc0 = {
  classMap: {
    "popover-wrapper": true
  },
  key: 0
};
const stc1 = {
  "close-button": true
};
const stc2 = {
  attrs: {
    "data-testid": "contentSlot"
  },
  key: 6
};
const stc3 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, sp: api_static_part, st: api_static_fragment, gid: api_scoped_id, b: api_bind, c: api_custom_element, s: api_slot, h: api_element} = $api;
  const {_m0, _m1} = $ctx;
  return [$cmp.show ? api_element("div", stc0, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    className: api_normalize_class_name($cmp.arrowClass)
  }, null)]), api_element("div", {
    className: api_normalize_class_name($cmp.popoverClass),
    attrs: {
      "aria-label": $cmp.ariaLabel,
      "aria-labelledby": api_scoped_id($cmp.ariaLabelledBy),
      "role": "dialog",
      "aria-modal": "false",
      "tabindex": "-1"
    },
    key: 3,
    on: {
      "keydown": _m0 || ($ctx._m0 = api_bind($cmp.handleInputKey))
    }
  }, [!$cmp.hideCloseButton ? api_custom_element("ax-icon-interactive", _axIconInteractive, {
    classMap: stc1,
    props: {
      "iconDescription": $cmp.closeButtonAriaLabel,
      "ariaLabel": $cmp.closeButtonAriaLabel,
      "icon": "close",
      "size": "xsmall"
    },
    key: 4,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClose))
    }
  }) : null, api_element("div", {
    className: api_normalize_class_name($cmp.contentClass),
    attrs: {
      "id": api_scoped_id("popover-content")
    },
    key: 5
  }, [api_slot("", stc2, stc3, $slotset)])])]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = [""];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5alo05e0feu";
tmpl.legacyStylesheetToken = "undefined-_popover";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
